import { Component, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { GenericService } from "../../services/base/generic-service";
import { GenericListViewFunctions } from "./generic-list-view-functions";

export class GenericListView<T> extends GenericListViewFunctions<T> {
    constructor(private agenericRepository: GenericService<T>, router: Router) {
        super(agenericRepository, router);
    }

    async PopulateListView() {
        await this.PopulateListViewGeneric(this.getListViewDataSourceURL, this.getRequestData);
    }

    //Scroll Pagination
    async PopulateListViewForOnScrollPagination() {
        await this.PopulateListViewGenericForOnScrollPagination(this.getListViewDataSourceURL, this.getRequestData);
    }

    async PopulateLineItemDataOnSelection() {
        return this.PopulateLineItemDataOnSelectionGeneric(this.getLineItemDataSourceURL, this.getLineItemRequestData);
    }

    pageIndex = 1;
    pageSize = 0;
  
    onScroll(event:any) {
        //alert('Hi')
        const tableViewHeight = event.target.offsetHeight // viewport
        const tableScrollHeight = event.target.scrollHeight // length of all table
        const scrollLocation = event.target.scrollTop; // how far user scrolled
  
        const buffer = 10;
  
        const limit = tableScrollHeight - tableViewHeight - buffer;
        if (scrollLocation > limit) {
            if (this.pageIndex < this.getPageRecordCount) {
                this.pageIndex = this.getCurrentPage + 1;
                this.pageSize += this.getPageSize;
                this.getRequestData.SortColumn;
                this.getRequestData.PageSize = this.pageIndex;
                this.setAppendDataSource = true;
                this.setIsPagination = true;
                this.PopulateListViewForOnScrollPagination();
  
            }
      }
  
    }

   
}
